import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isDateTimeInput(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.DATE_TIME_INPUT && typeof label === 'string' && typeof value === 'string';
}
export function formatDateTimeInput(submission) {
  if (isDateTimeInput(submission) && submission.value) {
    return {
      label: submission.field.view.label,
      value: submission.value
    };
  }
  return undefined;
}
//# sourceMappingURL=date-time-input-preview.js.map